import { shipmentStatus } from "constants/global";
import { formatDate } from "../utils";
import MoreOptionsDropdown from "../shipments/modals/MoreOptionsDropdown";
import currencyPairCheck from "utilities/currencyPairCheck";
import { Notepad2, NoteRemove, Printer, ReceiptEdit, Trash } from "iconsax-reactjs";
import { errorAlert } from "utilities/alerts";

export const invoiceTableData = ({ invoice, index, navigate, invoiceDropDownOptions }) => {
    return {
        columns: [
            {
                value: (
                    <div className="flex flex-col items-center justify-center">
                        <p className="text-sm font-semibold">{invoice?.invoiceNumber}</p>
                    </div>
                ),
                className: "text-gray-70",
            },
            {
                value: (
                    <div className="flex items-center text-sm font-semibold">
                        {currencyPairCheck(invoice?.currency)}
                        {invoice?.amount}
                    </div>
                ),
                className: "text-gray-70",
            },
            {
                value: (
                    <div className="flex items-center text-sm font-semibold gap-x-2">
                        <div className="flex text-xs justify-center shrink-0 rounded-full size-[28px] items-center bg-light-grey">
                            {invoice?.customer?.at(0)}
                        </div>{" "}
                        <span>{invoice.customer}</span>
                    </div>
                ),
                className: "text-gray-70",
            },
            {
                value: (
                    <span
                        style={{
                            backgroundColor: shipmentStatus[invoice?.status]?.bgColor || "#DBDFE5",
                            color: shipmentStatus[invoice?.status]?.textColor || "#B64607",
                        }}
                        className={`rounded-xl py-1 px-2 w-auto text-xs font-[350]`}
                    >
                        {shipmentStatus[invoice?.status]?.text || invoice.status}
                    </span>
                ),
                className: "text-main-grey",
            },
            {
                value: (
                    <div className="flex items-center text-sm font-normal gap-x-2 text-gray-70">
                        {formatDate(invoice?.issueDate, "MMM D YYYY")}
                    </div>
                ),
                className: "text-gray-70",
            },

            {
                value: (
                    <div className="flex items-center justify-between w-full gap-12 text-sm font-normal">
                        <span className="text-gray-70">
                            {formatDate(invoice.due, "MMM D YYYY")}
                        </span>
                        <MoreOptionsDropdown options={invoiceDropDownOptions(invoice)} />
                    </div>
                ),
                className: "text-gray-70",
            },
        ],
        rowId: index,
        onRowClick: () => {
            navigate("/invoice/manage/" + invoice?.id, {
                state: { ...invoice },
            });
        },
    };
};

export const outGoingInvoiceDropDown = ({
    invoice,
    navigate,
    downloadInvoiceFunc,
    setRecordPaymentModal,
    setSelectedInvoice,
    setShowDeleteModal,
}) => {
    return [
        {
            label: "Edit invoice",
            value: "edit-invoice",
            className: invoice.status === "PAID" ? "hidden" : "",
            icon: <ReceiptEdit />,
            action: () => {
                if (invoice.status !== "PAID") {
                    navigate("/invoice/create-invoice?invoiceIdToEdit=" + invoice?.id, {
                        state: { invoice, isEdit: true },
                    });
                } else {
                    errorAlert("You cannot edit a paid invoice");
                }
            },
        },
        {
            label: "Duplicate invoice",
            value: "duplicate-invoice",
            icon: <Notepad2 />,
            action: async () => {
                navigate("/invoice/create-invoice?invoiceIdToEdit=" + invoice?.id, {
                    state: { invoice, isDuplicating: true },
                });
            },
        },
        {
            label: "Generate PDF",
            value: "generate-PDF",
            icon: <Printer />,
            action: () => {
                downloadInvoiceFunc(invoice?.id);
            },
        },
        {
            label: "Record payment",
            value: "record-payment",
            className:
                invoice?.status === "DRAFT" || invoice?.status === "PAID" ? "hidden" : "block",
            icon: <NoteRemove />,
            action: () => {
                setRecordPaymentModal(true);
                setSelectedInvoice(invoice);
            },
        },
        {
            label: "Delete invoice",
            value: "delete-draft",
            className:
                (invoice?.paymentStatus === "DRAFT" ||  !invoice?.paidAmount)
                    ? "block text-red-500"
                    : "hidden",
            icon: <Trash />,
            action: () => {
                setShowDeleteModal(true);
                setSelectedInvoice(invoice);
            },
        },
    ];
};

export const incomingInvoiceDropDown = ({
    invoice,
    navigate,
    downloadInvoiceFunc,
    setMakePaymentModal,
    setSelectedInvoice,
}) => {
    return [
        {
            label: "Duplicate invoice",
            value: "duplicate-invoice",
            icon: <Notepad2 />,
            action: async () => {
                navigate("/invoice/create-invoice?invoiceIdToEdit=" + invoice?.id, {
                    state: { invoice, isDuplicating: true },
                });
            },
        },
        {
            label: "Generate PDF",
            value: "generate-PDF",
            icon: <Printer />,
            action: () => {
                downloadInvoiceFunc(invoice?.id);
            },
        },
        {
            label: "Make payment",
            value: "make-payment",
            className:
                invoice?.status === "DRAFT" || invoice?.status === "PAID" ? "hidden" : "block",
            icon: <NoteRemove />,
            action: () => {
                setSelectedInvoice(invoice);
                setMakePaymentModal(true);
            },
        },
    ];
};